import {fixedInterests} from "./AsxFixedInterests";
import {Exchange} from "../../../instruments/exchange/Exchange";

export class AsxFixedInterestsUtil {
    public static isFixedInterest(code: string): boolean {
        return fixedInterests.find((security) => security.code === code) != null;
    }

    public static exchange(code: string): Exchange {
        const fixedInterest = fixedInterests.find((security) => security.code === code);
        if (fixedInterest == null) {
            return Exchange.ASX;   // Dodgy as hell, but must return something. Brock is going to kill me.
        }
        return fixedInterest.exchange;
    }
}